import * as React from 'react';
export const redwoodSvg = React.forwardRef(function redwoodSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0D8255',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm15.96 5.19 1.78 6.04-4.51 15.5H9.5l6.45-21.54zm2.23 7.5 1.93 6.58-2.42 7.5h-3.58l4.07-14.08zm2.28 7.85 1.88 6.23h-3.71l1.83-6.23z',
      }),
    ),
  );
});
redwoodSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var redwood = {
  category: 'brand',
  colorable: false,
  name: 'redwood',
  svg: redwoodSvg,
};
